import { LoaderUI } from "./loaderUI";

export class Loader {
  private ui: LoaderUI = new LoaderUI();

  public enable() {
    this.ui.render(true);
  }

  public disable() {
    this.ui.render(false);
  }

}
